{
  "activity_page": {
    "title": "Activity"
  }
}
